export const DashboardWorkbench = ({
  workspaceTitle,
  navSections,
  activeKey,
  onNavigate,
  topActions,
  session,
  children,
}) => {
  const initials = (session?.full_name || "AA")
    .split(" ")
    .map((item) => item?.[0] || "")
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <section className="dashboard-showcase in-app" data-testid="dashboard-workbench">
      <div className="shell">
        <aside className="sidebar" data-testid="dashboard-sidebar">
          <div className="sb-logo">
            <div className="sb-logo-mark">
              <span>A</span>
            </div>
            <span className="sb-logo-text">Aavedak Portal</span>
          </div>

          {navSections.map((section, sectionIndex) => (
            <div key={section.title} data-testid={`sidebar-section-${sectionIndex}`}>
              <div className="sb-section">{section.title}</div>
              {section.items.map((item) => (
                <button
                  key={item.key}
                  className={`sb-item ${activeKey === item.key ? "active" : ""}`}
                  onClick={() => onNavigate(item.key)}
                  data-testid={`sidebar-item-${item.key}`}
                >
                  <span>{item.icon || "•"}</span> {item.label}
                </button>
              ))}
            </div>
          ))}

          <div className="sb-bottom" data-testid="sidebar-profile-section">
            <div className="avatar-row">
              <div className="avatar">{initials}</div>
              <div className="avatar-info">
                <p data-testid="sidebar-profile-name">{session?.full_name || "Aavedak User"}</p>
                <span data-testid="sidebar-profile-id">{session?.identifier || "-"}</span>
              </div>
            </div>
          </div>
        </aside>

        <div className="main" data-testid="dashboard-main">
          <div className="topbar" data-testid="dashboard-topbar">
            <h2 data-testid="dashboard-workspace-title">{workspaceTitle}</h2>
            <div className="topbar-right" data-testid="dashboard-top-actions">
              {topActions}
            </div>
          </div>
          <div className="content" data-testid="dashboard-content-area">
            {children}
          </div>
        </div>
      </div>
    </section>
  );
};
